import { PageContainer } from "@/components";

const CollegeProfile = () => {
  return (
    <PageContainer className="space-y-5">
      <div className="flex items-center justify-between">
        <div className="flex flex-col gap-1">
          <span className="text-sm font-medium text-gray-500">College</span>
          <h1 className="text-2xl font-bold">College Profile</h1>
        </div>
      </div>
      <div className="rounded-lg border bg-card text-card-foreground shadow-sm p-6">
        <p className="text-muted-foreground">
          College profile details and settings will be displayed here.
        </p>
      </div>
    </PageContainer>
  );
};

export default CollegeProfile;
